export default __webpack_public_path__ + "static/media/virtual_card_background.6a24892e.svg";